import { render, staticRenderFns } from "./ESports.vue?vue&type=template&id=38e2bd57&scoped=true&"
import script from "./ESports.vue?vue&type=script&lang=js&"
export * from "./ESports.vue?vue&type=script&lang=js&"
import style0 from "./ESports.vue?vue&type=style&index=0&id=38e2bd57&lang=scss&scoped=true&"
import style1 from "./ESports.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e2bd57",
  null
  
)

export default component.exports